import React from "react";
import { Select } from "antd";
import "./TabPanel.css";
import logo from "../../../assets/icons/logo.png";


export const TabPanel = ({tabs,handleTabSelection, removeTab, addNewTab, handleChange, activeTab,dashboardOptions}) => {
   
    return (
        <div className="tab-top-head">
            <div className="tab-panel">
                <div className="logo">
                    <img
                        src={logo}
                        alt="logo"
                        style={{ width: "24px", height: "24px" }}
                    />
                </div>
                <div className="tabs-content">
                    <div class="tabs">
                        {tabs && tabs.length && tabs.map((item,index) => {
                            return(
                                <div key={index} onClick={() => handleTabSelection(index, item.url)} className={activeTab === index ? "tab active" : "tab"}>
                            <span>{item.name}</span>
                            {item.name !== 'Test Version' && <button class="close-tab"  onClick={(e) => removeTab(e,item.name)}>×</button>}
                        </div>)})}
                        <button class="add-tab" onClick={() => addNewTab(true)}>+</button>
                    </div>
                </div>
            </div>
            <div className="search-bar">
                <Select
                    value={""}
                    showSearch
                    style={{
                        width: 240,
                    }}
                    placeholder="Search"
                    optionFilterProp="label"
                    onChange={handleChange}
                    options={dashboardOptions}
                />
            </div>
        </div>
    );
};
